<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-row class="mx-1">
    <edit-notification v-model="showEditNotificationDialog" :notification="selectedNotification" @clearSelectedNotification="clearSelectedNotification"></edit-notification>
    <new-notification v-model="showNewNotificationDialog"></new-notification>

    <v-col cols="12" class="d-flex justify-end mt-1">
        <v-btn color="kbPurple"
               dark
               @click="showNewNotificationDialog = true">{{ $t('general.addNotification') }}</v-btn>
    </v-col>

    <v-col cols="12" class="text-h6">
      <v-data-table :headers="headers"
                    :items="notifications"
                    class="elevation-2"
                    :loading="loadingNotifications"
                    :options.sync="options"
                    :footer-props="{
                  'items-per-page-text': `${$t('general.notifications')} ${$t('general.perPage')}`,
                  'items-per-page-options': [50, 100, 200]
                }"
                    :server-items-length="totalNotifications">
          <template v-slot:item="{ item }">
              <tr>
                  <td class="font-weight-bold text-capitalize">{{ item.name.toLowerCase() }}</td>
                  <td>{{ item.code }}</td>
                  <td class="px-0 mx-0">
                      <div class="data-table-actions d-flex justify-center align-center">
                          <v-btn icon text @click="showEditNotification(item)" color="kbDarkBlue">
                              <v-icon>edit</v-icon>
                          </v-btn>
                      </div>
                  </td>
              </tr>
          </template>

          <template v-slot:no-data>
              <v-row>
                  <v-col class="text-center" cols="12" v-if="loadingNotifications">
                      {{ $t('general.loadingNotifications') }}
                  </v-col>
                  <v-col cols="12" class="red--text text-center" v-else>
                      {{ $t('general.noNotificationsCreated') }}
                  </v-col>
              </v-row>
          </template>
      </v-data-table>
    </v-col>
  </v-row>
</template>

<script>
import { mapState } from 'vuex'
import EditNotification from '@/components/dialogs/Notifications/EditNotification.vue'
import NewNotification from '@/components/dialogs/Notifications/NewNotification.vue'
export default {
  components: { EditNotification, NewNotification },
  computed: {
    ...mapState({
      loadingNotifications: state => state.notifications.loadingNotifications,
      paginationNotifications: state => state.notifications.paginationNotifications,
      selectedApp: state => state.apps.selectedApp,
      totalNotifications: state => state.notifications.totalNotifications,
      notifications: state => state.notifications.notifications
    }),
    headers () {
      return [
        { text: this.$t('general.name'), value: 'name' },
        { text: this.$t('general.code'), value: 'code' },
        { text: this.$t('general.actions'), align: 'center', value: '', sortable: false }
      ]
    }
  },
  data () {
    return {
      options: {},
      selectedNotification: {},
      showEditNotificationDialog: false,
      showNewNotificationDialog: false
    }
  },
  methods: {
    clearSelectedNotification () {
      this.selectedNotification = {}
    },
    showEditNotification (notification) {
      this.selectedNotification = notification
      this.showEditNotificationDialog = true
    },
    getNotifications () {
      this.$store.commit('SET_PAGINATION_NOTIFICATIONS', { page: this.options.page, itemsPerPage: this.options.itemsPerPage, sortBy: this.options.sortBy[0], descending: this.options.sortDesc[0] })
      this.$store.dispatch('getNotifications')
    }
  },
  watch: {
    options: {
      handler () {
        this.getNotifications()
        this.$vuetify.goTo(0)
      },
      deep: true
    },
    selectedApp (value) {
      this.$store.dispatch('getNotifications')
    }
  }
}
</script>
